import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type", "placeholder", "loadOptions", "required", "useOnDark"];
import { PureComponent } from 'react';
import { pick } from 'underscore';
import emptyFunction from 'react-utils/emptyFunction';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UISelect from 'UIComponents/input/UISelect';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { isObject } from 'ContentUtils/helpers/ObjectHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => `ContentComponents.cmv2.fields.baseResource.${suffix}`;
class DelayedLoadSelector extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.loadOptions = this.loadOptions.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
  }
  get callbackArgs() {
    return [null, {
      options: this.props.options,
      pagination: {
        hasMore: false
      }
    }];
  }
  loadOptions(input = '', callback) {
    const {
      loadOptions,
      onLoadingChange
    } = this.props;
    /* Don't call the endpoint again on input change */
    if (input.length) {
      callback(...this.callbackArgs);
      return;
    }
    onLoadingChange(SyntheticEvent(true));
    loadOptions(input, () => {
      callback(callback(...this.callbackArgs));
      onLoadingChange(SyntheticEvent(false));
    });
  }
  onOpenChange(evt) {
    this.props.onOpenChange(evt);
    const {
      target: {
        value: isOpen
      }
    } = evt;
    /* Allow dropdown to trigger onChange before switching */
    setTimeout(() => {
      this.setState({
        isOpen
      });
    }, 0);
  }
  render() {
    const _this$props = this.props,
      {
        type,
        placeholder: userPlaceholder,
        required,
        useOnDark
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const selectProps = pick(rest,
    // @ts-expect-error UISelect.propTypes does exist at runtime
    Object.keys(UISelect.propTypes));
    const placeHolder = userPlaceholder || /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: i18nKey('placeholder'),
      options: {
        type: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`typeLabels.${type}`),
          options: {
            count: 1
          }
        })
      }
    });
    let {
      value
    } = this.props;
    if (isObject(value)) {
      value = undefined;
    }
    if (!this.state.isOpen) {
      return /*#__PURE__*/_jsx(UISelect, Object.assign({}, selectProps, {
        "data-selenium": this.props['data-selenium'],
        buttonUse: useOnDark ? 'form-on-dark' : 'form',
        placeholder: placeHolder,
        onOpenChange: this.onOpenChange,
        value: value
      }));
    }
    return /*#__PURE__*/_jsx(UISelect, Object.assign({}, selectProps, {
      "data-selenium": this.props['data-selenium'],
      buttonUse: useOnDark ? 'form-on-dark' : 'form',
      clearable: !required,
      placeholder: placeHolder,
      loadOptions: this.loadOptions,
      onOpenChange: this.onOpenChange,
      value: value
    }));
  }
}
DelayedLoadSelector.defaultProps = {
  options: [],
  onLoadingChange: emptyFunction,
  onOpenChange: emptyFunction,
  required: false
};
export default DelayedLoadSelector;